// Recurring donations list page (CHG-1240 / ITER-3363; wizard trigger added CHG-1247).
//
// Thin per the v8 brief: page files ≤30 LOC, all configuration in
// @generated/screens. Future generator regenerates
// recurringDonationListConfig from recurring-donation.entity-hint.yaml
// (CHG-1228) without touching this file.
//
// CHG-1247 addition: floating "New recurring" trigger button + conditional
// RecurringDonationCreateWizard mount. Additive only — ListPage + generated
// config UNCHANGED.
//
// Spec: specs/tier-05-experience/recurring-donations-v2.cross-screen.yaml.

import { ListPage } from "../components/composition";
import { recurringDonationListConfig } from "../generated/screens/recurring-donation-list";
import { RecurringDonationCreateWizard } from "../wizards/recurring-donation-create.generated";
import { WizardTriggerButton } from "../wizards/WizardTriggerButton";
import { useWizard } from "../wizards/useWizard";
import { wizardRegistry } from "../wizards/wizardRegistry";

export function RecurringDonations() {
  const wizard = useWizard("recurring-donation-create");
  return (
    <>
      <ListPage config={recurringDonationListConfig} />
      <WizardTriggerButton
        label="New recurring"
        onClick={wizard.open}
        requirePermission={wizardRegistry["recurring-donation-create"].manifest.trigger.permission}
        testId="trigger-recurring-donation-create"
      />
      <RecurringDonationCreateWizard open={wizard.isOpen} onClose={wizard.close} />
    </>
  );
}
